varying vec3 vColor;
varying float vAlpha;
varying float vSize;

void main()
{
    vec2 uv = gl_PointCoord;
    float distanceToCenter = length(uv - 0.5);

    // Soft circular particle with glow
    float core = 1.0 - smoothstep(0.0, 0.15, distanceToCenter);
    float glow = 0.05 / distanceToCenter - 0.1;
    glow = max(glow, 0.0);

    // Combine core and glow - reduced intensity
    float alpha = core * 0.5 + glow * 0.7;
    alpha *= vAlpha * 0.7;

    // Discard nearly invisible pixels for performance
    if(alpha < 0.01) discard;

    // Add subtle white core for sparkle effect - reduced
    vec3 finalColor = vColor * 0.85;
    float whiteness = core * 0.15 * vSize;
    finalColor = mix(finalColor, vec3(1.0), whiteness);

    gl_FragColor = vec4(finalColor, alpha);
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}
